<div class="row">
  <div class="col-12">
    <nb-card accent="primary">
      <nb-card-header> Analytics
      </nb-card-header>
      <nb-card-body>
        <strong>this is an Analytics contract</strong><br /><br />
      </nb-card-body>
    </nb-card>
  </div>
</div>
